import { render, staticRenderFns } from "./fee_ratio.vue?vue&type=template&id=582a90ca&scoped=true"
import script from "./fee_ratio.vue?vue&type=script&lang=js"
export * from "./fee_ratio.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "582a90ca",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/jenkins/workspace/web-page/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('582a90ca')) {
      api.createRecord('582a90ca', component.options)
    } else {
      api.reload('582a90ca', component.options)
    }
    module.hot.accept("./fee_ratio.vue?vue&type=template&id=582a90ca&scoped=true", function () {
      api.rerender('582a90ca', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "found/views/tpm/views/activity/marketing_activity/components/fee_ratio.vue"
export default component.exports